var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1378 1.04651H7.3703C3.45639 1.04651 1 3.81555 1 7.73572V18.3107C1 22.2309 3.44492 25 7.3703 25H18.6126C22.5431 25 24.9829 22.2309 24.9829 18.3107V13.1873",
    stroke: "#2962ff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74373 11.3888L18.2622 1.88732C18.832 1.31914 19.6044 1 20.4097 1C21.215 1 21.9873 1.31914 22.5571 1.88732L24.1102 3.43147C24.3923 3.71295 24.616 4.04717 24.7687 4.41502C24.9214 4.78288 25 5.17716 25 5.57535C25 5.97353 24.9214 6.36782 24.7687 6.73567C24.616 7.10353 24.3923 7.43774 24.1102 7.71923L14.5432 17.2716C14.0246 17.7895 13.3211 18.0805 12.5876 18.0806H7.81494L7.9347 13.2726C7.9522 12.5643 8.24187 11.8898 8.74373 11.3888V11.3888Z",
    stroke: "#2962ff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8174 3.35266L22.6347 9.1604",
    stroke: "#2962ff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.a1ff5f98161cc82c8119c824b00dab08.svg";
export { ForwardRef as ReactComponent };